// extracted by mini-css-extract-plugin
var _1 = "headerContainer__TEGFv";
var _2 = "headerWrapper__CuO_a";
var _3 = "left__k_MUU";
var _4 = "mainButton__ZXlL2";
var _5 = "right__uxgGD";
export { _1 as "headerContainer", _2 as "headerWrapper", _3 as "left", _4 as "mainButton", _5 as "right" }
export default { "headerContainer": _1, "headerWrapper": _2, "left": _3, "mainButton": _4, "right": _5 }
